import { render } from "./PolicyPagesDynamic.vue?vue&type=template&id=36925042"
import script from "./PolicyPagesDynamic.vue?vue&type=script&lang=js"
export * from "./PolicyPagesDynamic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__